import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ChartAccountsCategoryEnum } from 'taxtank-core';

@Component({
  selector: 'app-chart-accounts-manage-dialog',
  templateUrl: './chart-accounts-manage-dialog.component.html',
  styleUrls: ['./chart-accounts-manage-dialog.component.scss'],
  standalone: false
})
export class ChartAccountsManageDialogComponent implements OnInit {
  categoryLabel = 'Personal';
  constructor(@Inject(MAT_DIALOG_DATA) public category: ChartAccountsCategoryEnum) {}

  ngOnInit(): void {
    if (this.category) {
      this.categoryLabel = 'Depreciation';
    }
  }
}
